import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export default function CopyPill({ value, label, testId, className = "" }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    let ok = true;
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = value;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
      } catch {
        ok = false;
      }
    }
    if (ok) {
      setCopied(true);
      toast.success("Copied to clipboard", { description: value, duration: 2000 });
      setTimeout(() => setCopied(false), 1800);
    } else {
      toast.error("Couldn't copy — please copy manually");
    }
  };

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={copy}
      title={`Copy ${value}`}
      className={`group inline-flex max-w-full items-center gap-2 rounded-full border border-mist bg-white px-4 py-2 transition-all duration-200 hover:-translate-y-0.5 hover:border-pink hover:shadow-[0_8px_20px_-6px_rgba(242,0,94,0.35)] ${className}`}
    >
      <span className="hidden text-[11px] font-bold uppercase tracking-[0.14em] text-navy/40 sm:inline">
        {label}
      </span>
      <span className="truncate text-[13px] font-medium text-navy">{value}</span>
      {copied ? (
        <Check className="h-3.5 w-3.5 shrink-0 text-green" strokeWidth={3} />
      ) : (
        <Copy className="h-3.5 w-3.5 shrink-0 text-navy/40 transition-colors group-hover:text-pink" />
      )}
    </button>
  );
}
